import * as Cesium from "cesium";

/**
 * 场景名称标签：切换导览/剧本时浮在场景坐标上方
 */
export default class SceneLabel {
  constructor(viewer, options = {}) {
    this.viewer = viewer;
    this.groundHeight = options.groundHeight ?? 1110;
    this.lift = options.lift ?? 120;
    this.entity = viewer.entities.add({
      show: false,
      position: new Cesium.ConstantPositionProperty(
        Cesium.Cartesian3.fromDegrees(
          106.226152,
          38.485145,
          this.groundHeight + this.lift
        )
      ),
      label: {
        text: "",
        font: "bold 20px Noto Sans SC, PingFang SC, sans-serif",
        fillColor: Cesium.Color.fromCssColorString("#e8fbff"),
        outlineColor: Cesium.Color.fromCssColorString("#031820"),
        outlineWidth: 5,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        pixelOffset: new Cesium.Cartesian2(0, -20),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        showBackground: true,
        backgroundColor: Cesium.Color.fromCssColorString("#04141e").withAlpha(0.88),
        backgroundPadding: new Cesium.Cartesian2(16, 10),
        // 远距俯瞰也能看清
        scaleByDistance: new Cesium.NearFarScalar(800, 1.2, 80000, 0.7),
        translucencyByDistance: new Cesium.NearFarScalar(100, 1.0, 120000, 1.0),
      },
      point: {
        pixelSize: 10,
        color: Cesium.Color.fromCssColorString("#3de7ff"),
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 2,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        scaleByDistance: new Cesium.NearFarScalar(800, 1.0, 80000, 0.6),
      },
    });
  }

  setGroundHeight(h) {
    this.groundHeight = h;
  }

  /**
   * @param {string} name 场景名
   * @param {number} lng
   * @param {number} lat
   * @param {number} [lift] 相对地表抬升
   */
  show(name, lng, lat, lift) {
    const h = this.groundHeight + (lift ?? this.lift);
    this.entity.position = new Cesium.ConstantPositionProperty(
      Cesium.Cartesian3.fromDegrees(lng, lat, h)
    );
    this.entity.label.text = String(name || "");
    this.entity.show = true;
  }

  hide() {
    this.entity.show = false;
  }
}
